module.exports = __webpack_public_path__ + "media/team/Sam-2f2333fc.png";